/* JAMILA JAMA'S — Maison theme
   Vanilla JS, no dependencies. Each module guards for its own markup. */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Focus trap + scroll lock for overlays ---------- */
  let lastFocus = null;
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  const openLayer = (el, focusEl) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    const target = focusEl || $(FOCUSABLE, el);
    if (target) setTimeout(() => target.focus({ preventScroll: true }), 60);
  };
  const closeLayer = (el) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open, .mmenu.is-open, .search-overlay.is-open, .club.is-open')) {
      document.documentElement.classList.remove('is-locked');
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', (e) => {
    const open = $$('.drawer.is-open, .modal.is-open, .mmenu.is-open, .search-overlay.is-open, .club.is-open').pop();
    if (!open) return;
    if (e.key === 'Escape') { closeLayer(open); syncMenuButtons(); return; }
    if (e.key === 'Tab') {
      const items = $$(FOCUSABLE, open).filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  const setHeaderVars = () => {
    if (!header) return;
    const h = header.offsetHeight;
    document.documentElement.style.setProperty('--header-h', h + 'px');
    const visible = !header.classList.contains('is-hidden');
    document.documentElement.style.setProperty('--header-offset', visible ? h + 'px' : '0px');
  };
  if (header) {
    const transparent = header.classList.contains('site-header--transparent') || header.classList.contains('site-header--navover');
    const autohide = header.classList.contains('site-header--autohide');
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      if (transparent) header.classList.toggle('is-solid', y > 40 || header.matches(':hover') || header.querySelector('.is-open') !== null);
      if (autohide) {
        const goingDown = y > lastY && y > 240;
        const anyOpen = header.querySelector('.site-nav__item.is-open');
        header.classList.toggle('is-hidden', goingDown && !anyOpen);
      }
      lastY = y;
      setHeaderVars();
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    window.addEventListener('resize', setHeaderVars);
    if (transparent) {
      header.addEventListener('mouseenter', () => header.classList.add('is-solid'));
      header.addEventListener('mouseleave', () => { if (window.scrollY <= 40 && !header.querySelector('.is-open')) header.classList.remove('is-solid'); });
      header.addEventListener('focusin', () => header.classList.add('is-solid'));
    }
    onScroll();
    setHeaderVars();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderVars);

    /* Mega menu: hover intent + keyboard */
    $$('[data-mega]', header).forEach((item) => {
      let timer;
      const link = $('.site-nav__link', item);
      const open = () => { clearTimeout(timer); $$('[data-mega].is-open', header).forEach((o) => o !== item && o.classList.remove('is-open')); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); header.classList.add('is-solid'); };
      const close = () => { timer = setTimeout(() => { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 160); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); link.focus(); } });
    });
  }

  /* ---------- Mobile menu ---------- */
  const mmenu = $('#MobileMenu');
  const syncMenuButtons = () => $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', mmenu && mmenu.classList.contains('is-open') ? 'true' : 'false'));
  if (mmenu) {
    const goPanel = (name) => {
      $$('[data-mmenu-panel]', mmenu).forEach((p) => {
        const active = p.dataset.mmenuPanel === name;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) { const f = $(FOCUSABLE, p); if (f) setTimeout(() => f.focus({ preventScroll: true }), 300); }
      });
    };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-menu-open]')) { goPanel('root'); openLayer(mmenu); syncMenuButtons(); }
      if (e.target.closest('[data-menu-close]')) { closeLayer(mmenu); syncMenuButtons(); }
      const go = e.target.closest('[data-mmenu-go]');
      if (go) goPanel(go.dataset.mmenuGo);
    });
  }

  /* ---------- Search overlay ---------- */
  const search = $('#SearchOverlay');
  if (search) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        if (mmenu) closeLayer(mmenu);
        openLayer(search, $('input[type="search"]', search));
      }
      if (e.target.closest('[data-search-close]')) closeLayer(search);
    });
  }

  /* ---------- Generic modals (size guide) ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.dataset.modalOpen)); }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) closeLayer(closer.closest('.modal'));
  });

  /* ---------- Reveal on scroll ---------- */
  const observeReveals = (root = document) => {
    const items = $$('[data-reveal]:not(.is-in)', root);
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    items.forEach((el) => io.observe(el));
  };
  observeReveals();
  document.addEventListener('shopify:section:load', (e) => observeReveals(e.target));

  /* ---------- Money formatting ---------- */
  const formatMoney = (cents) => {
    const format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withDelims = (n, dec, thou, sep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  };

  /* ---------- Cart drawer ---------- */
  const cartDrawer = () => $('#CartDrawer');
  const updateCount = (count) => $$('[data-cart-count]').forEach((n) => {
    n.textContent = count > 0 ? count : '';
    n.hidden = !(count > 0);
  });
  const refreshCart = async (sectionsHtml) => {
    let html = sectionsHtml;
    if (!html) {
      const res = await fetch(`${routes.root}?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-contents]', doc);
    const current = $('[data-cart-contents]', cartDrawer());
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const cart = await fetch(`${routes.cart}.js`).then((r) => r.json());
    updateCount(cart.item_count);
  };
  const openCart = () => openLayer(cartDrawer());
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && cartDrawer() && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeLayer(cartDrawer());
  });
  const changeLine = async (key, quantity) => {
    const drawer = cartDrawer();
    drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      await refreshCart(data.sections && data.sections['cart-drawer']);
    } finally { drawer.classList.remove('is-loading'); }
  };
  document.addEventListener('click', (e) => {
    const line = e.target.closest('#CartDrawer .cart-line');
    if (!line) return;
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const current = parseInt($('.qty__val', line).textContent, 10) || 0;
      changeLine(line.dataset.key, Math.max(0, current + parseInt(qtyBtn.dataset.qtyChange, 10)));
    }
    if (e.target.closest('[data-remove]')) changeLine(line.dataset.key, 0);
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach((section) => {
    const form = $('[data-product-form]', section);
    const jsonEl = $('[data-product-json]', section);
    if (!form || !jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addButtons = $$('[data-add-button]', section);
    const errorEl = $('[data-form-error]', section);
    const fieldsets = $$('.opt', form);

    const selectedOptions = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = () => {
      const opts = selectedOptions();
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => o === test[i]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    const setButtons = (variant) => {
      addButtons.forEach((btn) => {
        const label = $('[data-add-label]', btn);
        if (!variant) { btn.disabled = true; label.textContent = 'Unavailable'; }
        else if (!variant.available) { btn.disabled = true; label.textContent = 'Coming soon'; }
        else { btn.disabled = false; label.textContent = 'Add to Bag'; }
      });
    };

    const onChange = () => {
      const opts = selectedOptions();
      fieldsets.forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = opts[i] || ''; });
      const variant = findVariant(opts);
      setButtons(variant);
      markAvailability();
      if (!variant) return;
      idInput.value = variant.id;
      const priceEl = $('.pdp__price [data-price]', section);
      if (priceEl) {
        let html = `<span class="price__current">${formatMoney(variant.price)}</span>`;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) html += `<s class="price__compare"><span class="visually-hidden">Was</span> ${formatMoney(variant.compare_at_price)}</s>`;
        priceEl.innerHTML = html;
      }
      const sticky = $('[data-sticky-price]', section);
      if (sticky) sticky.textContent = formatMoney(variant.price);
      const url = new window.URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) {
        const target = $(`[data-media-id="${variant.featured_media}"]`, section);
        const track = $('[data-gallery-track]', section);
        if (target && track) {
          if (window.matchMedia('(max-width: 989px)').matches) track.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          else if (target !== track.firstElementChild) track.prepend(target);
        }
      }
    };
    form.addEventListener('change', (e) => { if (e.target.matches('.opt__input')) onChange(); });
    if (fieldsets.length) markAvailability();

    form.addEventListener('submit', async (e) => {
      if (!cartDrawer()) return;
      e.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addButtons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      try {
        const res = await fetch(`${routes.cartAdd}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }], sections: ['cart-drawer'] })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'This piece could not be added.');
        await refreshCart(data.sections && data.sections['cart-drawer']);
        openCart();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      } finally {
        addButtons.forEach((b) => b.removeAttribute('aria-busy'));
        setButtons(findVariant(selectedOptions()) || product.variants.find((v) => String(v.id) === String(idInput.value)));
      }
    });

    /* Mobile gallery counter */
    const track = $('[data-gallery-track]', section);
    const indexEl = $('[data-gallery-index]', section);
    if (track && indexEl) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        indexEl.textContent = i + 1;
      }, { passive: true });
    }

    /* Sticky add to bag (mobile) */
    const sticky = $('[data-sticky-atc]', section);
    const anchor = $('[data-atc-anchor]', section);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        const btn = $('button', sticky); if (btn) btn.tabIndex = show ? 0 : -1;
      }).observe(anchor);
    }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.card')) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; observeReveals(el); }
    } catch (_) { /* silent */ }
  });

  /* ---------- Collection: filters + sort ---------- */
  const filterPanel = $('#FilterPanel');
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-filter-open]');
    if (open && filterPanel) { openLayer(filterPanel); open.setAttribute('aria-expanded', 'true'); }
    if (e.target.closest('[data-filter-close]') && filterPanel) { closeLayer(filterPanel); $$('[data-filter-open]').forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  });
  $$('[data-sort]').forEach((select) => select.addEventListener('change', () => {
    const url = new window.URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));


  /* ---------- Currency selector ---------- */
  $$('[data-currency]').forEach((wrap) => {
    const btn = $('[data-currency-toggle]', wrap);
    const list = $('[data-currency-list]', wrap);
    const input = $('[data-currency-input]', wrap);
    const set = (open) => { list.hidden = !open; btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', (e) => { e.stopPropagation(); set(list.hidden); });
    $$('.currency__opt', wrap).forEach((opt) => opt.addEventListener('click', () => { input.value = opt.dataset.country; }));
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) set(false); });
    wrap.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
  });

  /* ---------- Favourites (wishlist, saved in this browser) ---------- */
  const WKEY = 'jj-favourites';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (_) { return []; } };
  const writeWish = (list) => { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (_) {} };
  const paintWish = () => {
    const list = readWish();
    $$('[data-wish]').forEach((b) => {
      const on = list.includes(b.dataset.wish);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Remove from favourites' : 'Add to favourites');
    });
    $$('[data-wishlist-count]').forEach((n) => { n.textContent = list.length || ''; n.hidden = list.length === 0; });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const list = readWish();
    const i = list.indexOf(b.dataset.wish);
    if (i > -1) list.splice(i, 1); else list.unshift(b.dataset.wish);
    writeWish(list);
    paintWish();
    if (b.closest('[data-wishlist-grid]') && i > -1) renderWishlist();
  });
  const renderWishlist = async () => {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    const empty = $('[data-wishlist-empty]');
    const list = readWish();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    const cards = await Promise.all(list.map((h) => fetch(`${routes.root.replace(/\/$/, '')}/products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    grid.innerHTML = cards.filter(Boolean).map((html) => `<div class="plp__item">${html}</div>`).join('');
    $$('[data-reveal]', grid).forEach((el) => el.classList.add('is-in'));
    paintWish();
  };
  paintWish();
  renderWishlist();

  /* ---------- The JJ Club modal ---------- */
  const club = $('#JJClub');
  if (club) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-club-open]')) { e.preventDefault(); if (mmenu) closeLayer(mmenu); openLayer(club, $('#JJClubEmail', club) || $('.club__x', club)); }
      if (e.target.closest('[data-club-close]')) closeLayer(club);
    });
    // After submitting, Shopify reloads the page: reopen the modal to show the result.
    if (window.location.hash === '#JJClubForm' && ($('[data-club-success]', club) || $('[data-club-error]', club))) openLayer(club, $('.club__x', club));
  }

  /* ---------- Account: recover password toggle ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-recover-toggle]');
    if (t) { e.preventDefault(); const r = $('#recover'); if (r) r.classList.toggle('is-open'); }
  });
})();
